import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaGlobe, FaLayerGroup, FaMobileAlt, FaTools } from 'react-icons/fa';
import PermissionTableCard from './PermissionTableCard';
import PermissionsSectionHeader from './PermissionsSectionHeader';
import { getAssistencias } from 'views/Assistencias/assistenciasApi';
import {
  API_PERMISSION_PAGES,
  SGU_PERMISSION_PAGES,
  APP_PERMISSION_PAGES,
  WEB_ASSISTENCIA_PAGES,
} from './permissionsConfig';
import {
  canAccessAssistenciaNavigation,
  canEditSguRestrictedPermission,
} from 'constants/assistenciaNavigation';

const PermissionsGrid = ({ user, setUser, permission, theme }) => {
  const canEdit = permission?.users?.write;
  const refreshUser = () => setUser({ ...user });
  const loggedInUser = JSON.parse(localStorage.getItem('userData') || 'null');
  const showWebAssistenciaCard = canAccessAssistenciaNavigation(loggedInUser);
  const canEditSguRestricted = canEditSguRestrictedPermission(loggedInUser);
  const sguPermissionPages = canEditSguRestricted
    ? SGU_PERMISSION_PAGES
    : SGU_PERMISSION_PAGES.filter((page) => page.key !== 'restricted');
  const [assistenciaOptions, setAssistenciaOptions] = useState([]);

  useEffect(() => {
    if (!showWebAssistenciaCard) return undefined;

    let isMounted = true;

    (async () => {
      try {
        const assistencias = await getAssistencias();
        if (!isMounted) return;

        setAssistenciaOptions(
          assistencias.map((assistencia) => ({
            value: assistencia._id,
            label: assistencia.nome || assistencia._id,
          }))
        );
      } catch (error) {
        console.error('Erro ao carregar assistências:', error);
        if (isMounted) setAssistenciaOptions([]);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [showWebAssistenciaCard]);

  const handleAssistenciaIdChange = (assistenciaId) => {
    setUser({ ...user, assistenciaId });
  };

  const handleMasterChange = (isChecked) => {
    if (!user.permission) user.permission = {};
    Object.keys(user.permission).forEach((key) => {
      if (user.permission[key]?.read !== undefined) user.permission[key].read = isChecked;
      if (user.permission[key]?.write !== undefined) user.permission[key].write = isChecked;
    });
    user.master = isChecked;
    refreshUser();
  };

  return (
    <>
      <PermissionsSectionHeader theme={theme} />

      <Row className="g-3 mb-2 permissions-grid-row">
        <Col xs={12} xl={6} className="permissions-grid-stack">
          <PermissionTableCard
            title="Site API"
            icon={FaGlobe}
            pages={API_PERMISSION_PAGES}
            permissions={user.permission}
            canEdit={canEdit}
            theme={theme}
            accent="api"
            showMasterRow
            masterChecked={Boolean(user.master)}
            onMasterChange={handleMasterChange}
            onUpdate={() => {
              if (!user.permission) user.permission = {};
              refreshUser();
            }}
          />
        </Col>

        <Col xs={12} xl={6} className="permissions-grid-stack">
          <PermissionTableCard
            title="Site SGU"
            icon={FaLayerGroup}
            pages={sguPermissionPages}
            permissions={user.permissionSGU}
            canEdit={canEdit}
            theme={theme}
            accent="sgu"
            showToggleAll={false}
            onUpdate={() => {
              if (!user.permissionSGU) user.permissionSGU = {};
              refreshUser();
            }}
          />

          {showWebAssistenciaCard ? (
            <PermissionTableCard
              title="Web Assistência"
              icon={FaTools}
              pages={WEB_ASSISTENCIA_PAGES}
              permissions={user.permissionWebAssistencia}
              rootSelects={[
                {
                  key: 'assistenciaId',
                  label: 'Assistência',
                  value: user.assistenciaId || '',
                  options: assistenciaOptions,
                  onChange: handleAssistenciaIdChange,
                },
              ]}
              canEdit={canEdit}
              theme={theme}
              accent="assistencia"
              onUpdate={() => {
                if (!user.permissionWebAssistencia) user.permissionWebAssistencia = {};
                refreshUser();
              }}
            />
          ) : null}

          <PermissionTableCard
            title="App Assistance"
            icon={FaMobileAlt}
            pages={APP_PERMISSION_PAGES}
            permissions={user.permissionAssist}
            canEdit={canEdit}
            theme={theme}
            accent="app"
            onUpdate={() => {
              if (!user.permissionAssist) user.permissionAssist = {};
              refreshUser();
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default PermissionsGrid;
